import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { RayMeter } from "@/components/brand/RayMeter";
import { ButtonLink } from "@/components/ui/Button";
import { SHOW_SISTEMA_LUCENTIA } from "@/config/features";
import { usePageSeo } from "@/hooks/usePageSeo";
import { useAppTranslation } from "@/i18n/useAppTranslation";

export function NotFoundPage() {
  const { pathname } = useLocation();
  usePageSeo(pathname);
  const { t } = useAppTranslation("common");
  const { t: tNav } = useAppTranslation("nav");

  const links = [
    ...(SHOW_SISTEMA_LUCENTIA ? [{ to: "/metodo", label: "Sistema Lucentia®" }] : []),
    { to: "/precios", label: tNav("pricing") },
    { to: "/gestion-instagram", label: tNav("services") },
    { to: "/recursos", label: tNav("freeGuide") },
  ];

  return (
    <main id="main-content" tabIndex={-1} className="light-pool outline-none [--pool-x:50%] [--pool-y:30%]">
      <div className="mx-auto flex min-h-[80svh] max-w-3xl flex-col items-center justify-center px-4 pb-20 pt-32 text-center sm:px-6">
        <RayMeter lit={0} className="size-28" />
        <h1 className="mt-8 font-display text-[clamp(2.4rem,5vw,3.75rem)] font-semibold leading-tight tracking-[-0.02em] text-brand-primary">
          {t("notFoundTitle")}
        </h1>
        <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink-soft">{t("notFoundBody")}</p>
        <ul className="mt-8 flex flex-wrap justify-center gap-3">
          {links.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className="inline-flex min-h-11 items-center gap-2 rounded-full border border-brand-primary/15 bg-white px-5 font-medium text-brand-primary transition-colors hover:border-brand-secondary hover:bg-teal-soft"
              >
                {link.label}
                <ArrowRight aria-hidden="true" className="size-4" />
              </Link>
            </li>
          ))}
        </ul>
        <ButtonLink to="/" className="mt-10" arrow>
          {t("backHome")}
        </ButtonLink>
      </div>
    </main>
  );
}
